import React, { useState } from "react";
import api, { apiError } from "../lib/api";
import { AlertTriangle, Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

const GRACE_DAYS = 14;

export const PastDueBanner = ({ membership, isAdmin }) => {
  const [busy, setBusy] = useState(false);
  if (!isAdmin || membership?.subscription !== "past_due") return null;
  const locked = membership.locked;
  const daysLeft = membership.past_due_since
    ? Math.max(0, GRACE_DAYS - Math.floor((Date.now() - new Date(membership.past_due_since)) / 86400000))
    : GRACE_DAYS;

  const fix = async () => {
    setBusy(true);
    try { const { data } = await api.post("/billing/portal", { origin_url: window.location.origin }); window.location.href = data.url; }
    catch (e) { toast.error(apiError(e)); setBusy(false); }
  };

  return (
    <div role="alert" data-testid={locked ? "service-locked-banner" : "past-due-banner"} className={`flex flex-wrap items-center justify-between gap-3 px-5 py-3 text-white sm:px-8 ${locked ? "bg-rose-800" : "bg-rose-600"}`}>
      <p className="flex items-center gap-2 text-sm font-semibold">
        {locked ? <Lock className="h-4 w-4 shrink-0" /> : <AlertTriangle className="h-4 w-4 shrink-0" />}
        {locked
          ? "Service paused: payment has been past due for over 14 days. Consent links and session rooms are offline until the card is updated."
          : `Your last card payment failed. Consent links and session rooms will pause in ${daysLeft} day${daysLeft === 1 ? "" : "s"} unless the payment method is updated.`}
      </p>
      <button onClick={fix} disabled={busy} data-testid="past-due-fix" className="inline-flex items-center rounded-full bg-white px-4 py-1.5 text-xs font-bold text-rose-700 hover:bg-rose-50 disabled:opacity-70">
        {busy && <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />} {locked ? "Restore service" : "Fix payment now"}
      </button>
    </div>
  );
};
